import { render, staticRenderFns } from "./companyDetailForeign.vue?vue&type=template&id=60e26188&"
import script from "./companyDetailForeign.vue?vue&type=script&lang=js&"
export * from "./companyDetailForeign.vue?vue&type=script&lang=js&"
import style0 from "./companyDetailForeign.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports